import React from 'react';
import { Icon, type IconProps } from 'src/components/icon/icon';
import { Text } from 'src/components/text/Text';
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';

import styles from './OptionList.css';

export const OptionList = () => {
  const t = useLocale();
  const { currency } = useAppContext();

  const country = COUNTRY_NAME_BY_CURRENCY_MAP[currency];
  const options: { icon: IconProps['name']; label: string }[] = [
    country === 'saudi'
      ? { icon: 'asterisks', label: t('no_late_fees') }
      : { icon: 'asterisks', label: t('no_processing_fees') },
    country === 'saudi'
      ? { icon: 'moon', label: t('shariah_compliant') }
      : { icon: 'card', label: t('use_any_card') },
    { icon: 'protection', label: t('buyer_protection') },
  ];

  return (
    <div className={styles.OptionList} data-test="card-widget-option-list">
      {options.map(({ icon, label }, index) => (
        <div
          key={index}
          className={styles.OptionList__Option}
          data-test={`card-widget-option-${index}`}
        >
          <div className={styles.OptionList__Icon}>
            <Icon name={icon} />
          </div>
          <Text as="span" variant="caption">
            {label}
          </Text>
        </div>
      ))}
    </div>
  );
};
